import { render, staticRenderFns } from "./PainelAnexoEdicao.vue?vue&type=template&id=43ff3d3c&scoped=true"
import script from "./PainelAnexoEdicao.vue?vue&type=script&lang=js"
export * from "./PainelAnexoEdicao.vue?vue&type=script&lang=js"
import style0 from "./PainelAnexoEdicao.vue?vue&type=style&index=0&id=43ff3d3c&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ff3d3c",
  null
  
)

export default component.exports